import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import {
  FiHome,
  FiBarChart2,
  FiUsers,
  FiTarget,
  FiFilter,
  FiUser,
  FiLogOut,
  FiLayout,
  FiCode,
  FiShield,
  FiActivity,
  FiTrendingUp,
  FiCpu,
  FiZap,
  FiFolder,
  FiShoppingBag
} from 'react-icons/fi';

function AdminSidebar({ isOpen, closeSidebar }) {
  const location = useLocation();
  const { logout, hasSectionAccess, user } = useAuth();

  const menuItems = [
    { path: '/admin', icon: FiHome, label: 'Dashboard', section: 'dashboard' },
    { path: '/admin/vendas', icon: FiShoppingBag, label: 'Vendas', section: 'vendas' },
    { path: '/admin/relatorios', icon: FiBarChart2, label: 'Relatórios', section: 'relatorios' },
    { path: '/admin/monitoramento', icon: FiActivity, label: 'Monitoramento', section: 'monitoramento' },

    { path: '/admin/bi-metas', icon: FiTrendingUp, label: 'BI de Metas', section: 'bi_metas' },
    { path: '/admin/vendedores', icon: FiUsers, label: 'Vendedores', section: 'vendedores' },
    { path: '/admin/metas', icon: FiTarget, label: 'Metas', section: 'metas' },
    { path: '/admin/grupos-metas', icon: FiFolder, label: 'Grupos de Metas', section: 'grupos_metas' },
    { path: '/admin/filtros', icon: FiFilter, label: 'Filtros', section: 'filtros' },
    { path: '/admin/variaveis', icon: FiCode, label: 'Variáveis', section: 'variaveis' },
    { path: '/admin/funcionarios', icon: FiUsers, label: 'Funcionários Winthor', section: 'funcionarios' },
    { path: '/admin/modulos', icon: FiCpu, label: 'Módulos', section: 'modulos' },
    { path: '/admin/ia', icon: FiZap, label: 'Inteligência IA', section: 'ia' },
    { path: '/admin/usuarios', icon: FiShield, label: 'Usuários', section: 'usuarios' },
    { path: '/admin/minha-conta', icon: FiUser, label: 'Minha Conta', section: 'minha_conta' }
  ].filter((item) => {
    if (item.section === 'usuarios' && user?.role !== 'admin') {
      return false;
    }
    return hasSectionAccess(item.section, 'view');
  });

  const handleLinkClick = () => {
    if (window.innerWidth <= 1024) {
      closeSidebar();
    }
  };

  const handleLogout = (e) => {
    e.preventDefault();
    logout();
    if (window.innerWidth <= 1024) {
      closeSidebar();
    }
  };

  return (
    <aside className={`sidebar-modern ${isOpen ? 'sidebar-open' : ''}`} id="sidebar">
      <div className="sidebar-header-modern">
        <div className="d-flex align-items-center gap-2">
          <div
            className="bg-primary text-white rounded-3 d-flex align-items-center justify-content-center"
            style={{ width: '36px', height: '36px' }}
          >
            <FiLayout size={20} />
          </div>
          <div>
            <h2 className="mb-0 fw-bold" style={{ fontSize: '1.05rem', lineHeight: 1.2 }}>
              Metas
            </h2>
            <span className="text-muted small" style={{ fontSize: '0.72rem' }}>
              Metas NovoTok
            </span>
          </div>
        </div>
      </div>

      <nav>
        {menuItems.map((item) => {
          const Icon = item.icon;
          const isExactHome = item.path === '/admin';
          const isActive = isExactHome
            ? location.pathname === '/admin' || location.pathname === '/admin/'
            : location.pathname === item.path || location.pathname.startsWith(`${item.path}/`);

          return (
            <Link
              key={item.path}
              to={item.path}
              className={isActive ? 'active' : ''}
              onClick={handleLinkClick}
              style={{ position: 'relative' }}
            >
              <Icon className="me-2 icon-sidebar-modern" />
              <span>{item.label}</span>
            </Link>
          );
        })}
      </nav>

      <div className="sidebar-footer-modern">
        <button
          type="button"
          onClick={handleLogout}
          className="logout-link-modern w-100 border-0 bg-transparent"
        >
          <FiLogOut className="me-2" />
          <span>Sair do Sistema</span>
        </button>
      </div>
    </aside>
  );
}

export default AdminSidebar;
